! function(e, t, s) {
	function n(e) {
		var t = /(youtube\.com\/(watch\?v=|v\/|embed\/)|youtu\.be\/)([\w-]+)/.exec(e),
			s = /[?&#]t=(\d+)/.exec(e);
		return !(!t || !t[3]) && {
			id: t[3],
			t: s && s[1]
		}
	}

	function i(e, t, s) {
		var n = JSON.stringify({
			event: "command",
			func: t,
			args: s || []
		});
		e.src.indexOf("youtube.com/embed") !== -1 && e.contentWindow.postMessage(n, "*")
	}

	function a(t, n, a, h) {
		function p() {
			var e = o.width() - t.minPaddingX,
				s = o.height() - t.minPaddingY,
				n = e / s,
				i = t.ratio;
			n > i ? (y.height(s), y.width(s * i)) : (y.width(e), y.height(e / i)), y.css("left", (o.width() - y.width()) / 2), y.css("top", (o.height() - y.height()) / 2)
		}

		function v() {
			i(E[0], "playVideo"), m()
		}

		function m() {
			b.stop().fadeIn("fast"), y.stop().fadeIn("fast")
		}

		function C() {
			b.stop().fadeOut("fast"), y.stop().fadeOut("fast", function() {
				null === n && t.open && (b.remove(), y.remove())
			})
		}

		function g(e) {
            v();
		}

		function w(e) {
			e.on("click", function(e) {
				e.preventDefault(), i(E[0], "pauseVideo"), C()
			})
		}
		var y = e(s.createElement("DIV")).addClass(t.cssClass).css(f),
			b = e(s.createElement("DIV")).addClass(t.cssClass + t.overlayCssClass).css(u),
			x = e(s.createElement("BUTTON")).addClass(t.cssClass + t.closeCssClass).html(t.closeText),
			E = e(s.createElement("IFRAME")).addClass(t.cssClass + t.iframeCssClass).attr({
				src: d + a + c + h + l
			}).css(r);
		y.append(E).append(x), e("body").append(b).append(y), t.open && E.on("load", function() {
			v()
		}), null !== n && g(n), w(x.add(b)), o.on("resize", p).trigger("resize")
	}
	var o = e(t),
		d = "https://www.youtube.com/embed/",
		c = "?start=",
		l = "&enablejsapi=1",
		f = {
			display: "none",
			position: "fixed"
		},
		r = {
			width: "100%",
			height: "100%"
		},
		u = {
			display: "none",
			position: "fixed",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%"
		},
		h = {
			minPaddingX: 50,
			minPaddingY: 50,
			ratio: 16 / 9,
			cssClass: "lcytvid",
			overlayCssClass: "-overlay",
			iframeCssClass: "-iframe",
			closeCssClass: "-close",
			closeText: "X",
			open: !1,
			vid: !1,
			t: 0
		};
	e.lcytvid = function(t) {
		var s = e.extend({}, h, t);
		if (s.vid === !1) throw "YOU MUST SET THE 'vid' option";
		a(s, null, s.vid, s.t)
	}, e.fn.lcytvid = function(t) {
		function s() {
			var t = e(this),
				s = n(t.attr("href"));
			a(i, t, s.id, s.t)
		}
		var i = e.extend({}, h, t);
		return i.vid !== !1 ? (a(i, this, i.vid, i.t), this) : this.each(s)
	}
}(jQuery, window, document);